import React, {useState} from 'react';
import {Box, Grid} from "@mui/material";
import ReactPaginate from "react-paginate";
import {useSelector, useDispatch} from "react-redux";
import {proactiveActions} from "_actions";
import RetainConversationBox from "../RetainConversationBox";
import _ from "lodash";
import styles from "../Utilities/styles.module.css"
import {SummaryCard} from "../Utilities/SummaryCard";
import {ConversionContainer} from "../Utilities/ConversionContainer";
import {RetainMessageList} from "../RetainMessageList";
import ConversationEmptyState from "../Utilities/ConversationEmptyState";
import ConversionEmptyState from "../Utilities/ConversionEmptyState";
import LoadingPlaceholderBlock from "../../../../common/LoadingPlaceholderBlock";

export const RetainMessagesBox = ({source, organizationId, messageList, allMessagesCount, eachPageMessagesCount, selectedCheckboxes, pageParams, setPageParams, loading, channel, pageFilter}) => {
    const proactive = useSelector((state) => state.proactive)
    const conversationThread = useSelector((state) => proactive.proactiveMsgConversation)
    const conversionOrders = useSelector((state) => proactive.proactiveConversionOrders)
    const loadingConversation = proactive.loadingProactiveMsgConversation;
    const loadingConversion = proactive.loadingConversionOrders;
    const dispatch = useDispatch();
    const [messageLink, setMessageLink] = useState("");
    const [messageSource, setMessageSource] = useState("");
    const [retainaiSkipped, setRetainaiSkipped] = useState(false);

    const handlePageSelect = (page) => {
        if (conversationThread?.length > 0) {
            dispatch(proactiveActions.clearConversation())
        }
        setPageParams({offset: page.selected * 10, currentPage: page.selected})
    }

    const getTotalPages = () => {
        if (allMessagesCount <= 0 || eachPageMessagesCount <= 0) {
            return 0;
        }
        return Math.ceil(allMessagesCount / eachPageMessagesCount);
    }

    const totalPages = getTotalPages();
    const messageCountStart = pageParams.offset + 1;
    const totalMsgsCount = allMessagesCount
    const messageCountEnd = pageParams.offset + eachPageMessagesCount

    function Content() {
        return(
             conversationThread.map((conversation, index) =>
                <RetainConversationBox
                    key={_.get(conversation, 'id')}
                    message={conversation}
                    index={index}
                    source={source}
                />
            )
        )
    }

    return(
        <div className={styles.msgBoxRootWrapper}>
            <Grid container>
                <Grid item xs={12} sm={12} md={3} lg={3}>
                    <div className={styles.msgBoxLeftContainer}>
                        <div className={styles.leftContainerHeading}>
                            {loading ?
                                <LoadingPlaceholderBlock
                                    width={"104px"}
                                    height={'22px'}
                                    borderRadius={'4px'}
                                    backgroundColor={'#EFEAE5'}
                            /> :
                            <span className={styles.proactiveMsgsBoxHeading2}>CUSTOMERS</span>
                            }
                        </div>
                        <div className={styles.msgListContainer}>
                            <div className={styles.msgListInnerPuhcd}>
                                <RetainMessageList
                                    source={source}
                                    organizationId={organizationId}
                                    msgList={messageList}
                                    selectedCheckboxes={selectedCheckboxes}
                                    setMessageLink={setMessageLink}
                                    setMessageSource={setMessageSource}
                                    loading={loading}
                                    channel={channel}
                                    pageFilter={pageFilter}
                                    setRetainaiSkipped={setRetainaiSkipped}
                                />
                            </div>
                        </div>

                        <div className={styles.paginationContainer}>
                            <span className={'fustat-medium'}> {allMessagesCount ? `${messageCountStart} - ${messageCountEnd} of ${totalMsgsCount}` : ""}</span>
                            {totalPages > 1 &&
                                <div className="md-pagination numberless-pagination">
                                    <div className={styles.font14}>
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageClassName="page-item-none"
                                            pageCount={totalPages}
                                            marginPagesDisplayed={0}
                                            disableInitialCallback
                                            pageRangeDisplayed={2}
                                            forcePage={pageParams.currentPage}
                                            onPageChange={page => handlePageSelect(page)}
                                            containerClassName={"pagination"}
                                            subContainerClassName={"pages pagination"}
                                            activeClassName={"active"}
                                            breakClassName="page-item-none"
                                            previousClassName={`previous ${pageParams.currentPage === 0 ? "disabled" : ""}`}
                                            nextClassName={`next ${pageParams.currentPage === totalPages ? "disabled" : ""}`}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <div className={styles.retainMsgRightContainer}>
                        <Box sx={{overflowY: 'auto', height: "calc(100% - 0px)", padding: "20px"}}>
                            {loadingConversation && <ConversationEmptyState/>}
                            {!loadingConversation &&  conversationThread?.length > 0 &&
                                <div className={styles.retainMsgRightContainerInner}>
                                    <div className={styles.retainContentWrapper}>
                                        <Content/>
                                    </div>
                                </div>
                            }
                        </Box>

                        <div className={styles.viewSourceContainer}>
                            {conversationThread?.length > 0 &&
                                <a className="viewInSourceLink" target="_blank"
                                   rel="noreferrer noopener nofollow" href={messageLink}>
                                    View in <span
                                    className="viewInSourceLink text-transform-capitalize">{messageSource ? messageSource : 'source platform'}</span>
                                </a>
                            }
                        </div>
                    </div>
                </Grid>

                <Grid item xs={12} sm={12} md={3} lg={3}>
                    <div className={styles.retainSummaryContainer}>
                        <Box sx={{
                            overflowY: 'auto',
                            height: "calc(100% - 0px)",
                            padding: {xs: "20px", md: "20px 20px 20px 0px"}
                        }}>
                            { loadingConversion && <ConversionEmptyState/>}

                            { !loadingConversion && conversionOrders?.conversionOrderValue?.amount > 0 && !retainaiSkipped &&
                                <SummaryCard conversionOrders={conversionOrders}/>
                            }

                            { !loadingConversion && conversionOrders?.orders?.length > 0 &&
                                <ConversionContainer loading={loadingConversion} conversionOrders={conversionOrders} />
                            }
                        </Box>
                        <div className={styles.viewSourceContainer}></div>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
